export const ITAR_NOTICE_TITLE = 'ITAR Notice';
export const ITAR_TOOLTIP_EXPLANATION =
    'ITAR (International Traffic in Arms Regulations) is a set of United States government regulations that control the export of defense-related items, technical data, and services.';
export const ITAR_QUESTION =
    'Before uploading files, please tell us whether any files contain ITAR-controlled or export-controlled content.';
export const ITAR_YES_TITLE = 'ITAR content indicated';
export const ITAR_YES_EXPLANATION =
    "Thanks for letting us know. We're currently unable to quote ITAR-controlled projects due to capacity constraints, but we're actively working to support them again. Send a message below and your sales representative will help you explore quoting options.";
export const ITAR_YES_EXPLANATION_STAFF =
    'Thanks for letting us know. Please contact your manager for guidance on how to proceed with this ITAR-controlled project.';
export const ITAR_NO_TITLE = 'No ITAR content indicated';
export const ITAR_NO_CONFIRMATION = 'Confirmed: your files do not contain ITAR-controlled content.';
export const ITAR_CHANGE_ANSWER = 'Change answer';
export const ITAR_REQUIRED_ERROR = 'Please answer this question before uploading files.';

/** @deprecated Use ITAR_YES_EXPLANATION instead. */
export const ITAR_CAPACITY_MESSAGE = ITAR_YES_EXPLANATION;
